<template>
  <div id="vehicle-info">
    <div class="vehicle-summary">
      <!-- <label>VIN</label> -->
      <!-- <input type="text" :value="vin" disabled /> -->
      <label>Vehicle</label>
      <input type="text" :value="`${getVehicleAttribute('Model Year')} ${getVehicleAttribute('Make')} ${getVehicleAttribute('Model')}`" disabled />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    vehicle() {
      return this.$store.state.trip.vehicle;
    },
    vin() {
      return this.$store.state.trip['VIN'];
    },
  },
  methods: {
    getVehicleAttribute(attr) {
      try {
        return this.vehicle.Results.find(veh => veh.Variable === attr)['Value'];
      } catch(err) {
        return null;
      }
    }
  }
}
</script>

<style>

</style>
